import "moment/dist/locale/af";
import "moment/dist/locale/ar";
import "moment/dist/locale/ar-dz";
import "moment/dist/locale/ar-kw";
import "moment/dist/locale/ar-ly";
import "moment/dist/locale/ar-ma";
import "moment/dist/locale/ar-sa";
import "moment/dist/locale/ar-tn";
import "moment/dist/locale/az";
import "moment/dist/locale/be";
import "moment/dist/locale/bg";
import "moment/dist/locale/bm";
import "moment/dist/locale/bn";
import "moment/dist/locale/bo";
import "moment/dist/locale/br";
import "moment/dist/locale/bs";
import "moment/dist/locale/ca";
import "moment/dist/locale/cs";
import "moment/dist/locale/cv";
import "moment/dist/locale/cy";
import "moment/dist/locale/da";
import "moment/dist/locale/de";
import "moment/dist/locale/de-at";
import "moment/dist/locale/de-ch";
import "moment/dist/locale/dv";
import "moment/dist/locale/el";
import "moment/dist/locale/en-au";
import "moment/dist/locale/en-ca";
import "moment/dist/locale/en-gb";
import "moment/dist/locale/en-ie";
import "moment/dist/locale/en-il";
import "moment/dist/locale/en-nz";
import "moment/dist/locale/eo";
import "moment/dist/locale/es";
import "moment/dist/locale/es-do";
import "moment/dist/locale/es-us";
import "moment/dist/locale/et";
import "moment/dist/locale/eu";
import "moment/dist/locale/fa";
import "moment/dist/locale/fi";
import "moment/dist/locale/fo";
import "moment/dist/locale/fr";
import "moment/dist/locale/fr-ca";
import "moment/dist/locale/fr-ch";
import "moment/dist/locale/fy";
import "moment/dist/locale/ga";
import "moment/dist/locale/gd";
import "moment/dist/locale/gl";
import "moment/dist/locale/gom-latn";
import "moment/dist/locale/gu";
import "moment/dist/locale/he";
import "moment/dist/locale/hi";
import "moment/dist/locale/hr";
import "moment/dist/locale/hu";
import "moment/dist/locale/hy-am";
import "moment/dist/locale/id";
import "moment/dist/locale/is";
import "moment/dist/locale/it";
import "moment/dist/locale/it-ch";
import "moment/dist/locale/ja";
import "moment/dist/locale/jv";
import "moment/dist/locale/ka";
import "moment/dist/locale/kk";
import "moment/dist/locale/km";
import "moment/dist/locale/kn";
import "moment/dist/locale/ko";
import "moment/dist/locale/ku";
import "moment/dist/locale/ky";
import "moment/dist/locale/lb";
import "moment/dist/locale/lo";
import "moment/dist/locale/lt";
import "moment/dist/locale/lv";
import "moment/dist/locale/me";
import "moment/dist/locale/mi";
import "moment/dist/locale/mk";
import "moment/dist/locale/ml";
import "moment/dist/locale/mn";
import "moment/dist/locale/mr";
import "moment/dist/locale/ms";
import "moment/dist/locale/ms-my";
import "moment/dist/locale/mt";
import "moment/dist/locale/my";
import "moment/dist/locale/nb";
import "moment/dist/locale/ne";
import "moment/dist/locale/nl";
import "moment/dist/locale/nl-be";
import "moment/dist/locale/nn";
import "moment/dist/locale/pa-in";
import "moment/dist/locale/pl";
import "moment/dist/locale/pt";
import "moment/dist/locale/pt-br";
import "moment/dist/locale/ro";
import "moment/dist/locale/ru";
import "moment/dist/locale/sd";
import "moment/dist/locale/se";
import "moment/dist/locale/si";
import "moment/dist/locale/sk";
import "moment/dist/locale/sl";
import "moment/dist/locale/sq";
import "moment/dist/locale/sr";
import "moment/dist/locale/sr-cyrl";
import "moment/dist/locale/ss";
import "moment/dist/locale/sv";
import "moment/dist/locale/sw";
import "moment/dist/locale/ta";
import "moment/dist/locale/te";
import "moment/dist/locale/tet";
import "moment/dist/locale/tg";
import "moment/dist/locale/th";
import "moment/dist/locale/tl-ph";
import "moment/dist/locale/tlh";
import "moment/dist/locale/tr";
import "moment/dist/locale/tzl";
import "moment/dist/locale/tzm";
import "moment/dist/locale/tzm-latn";
import "moment/dist/locale/ug-cn";
import "moment/dist/locale/uk";
import "moment/dist/locale/ur";
import "moment/dist/locale/uz";
import "moment/dist/locale/uz-latn";
import "moment/dist/locale/vi";
import "moment/dist/locale/x-pseudo";
import "moment/dist/locale/yo";
import "moment/dist/locale/zh-cn";
import "moment/dist/locale/zh-hk";
import "moment/dist/locale/zh-tw";

import moment from "moment-timezone";
moment.locale("en");
